import React, { useMemo } from 'react';

import styled from 'styled-components';

import { FilterType } from 'src/app/components/lib/wizard/filters';

import { useDiscountWizardStateContext } from '../state';
import { RequirementsStepActions } from '../state/requirements';
import { RewardsStepActions } from '../state/rewards';

import { FILTER_RESOURCES } from './constants';

import type { FilterResourceType } from './filter';
import type { Filters } from '../state/requirements';

export function AppliedFilters({
  excludeCommas,
  requirement,
}: {
  excludeCommas?: boolean;
  requirement: number | 'reward';
}) {
  const { requirementsStepDispatch, requirementsStepState, rewardsStepState, rewardsStepDispatch } =
    useDiscountWizardStateContext();
  const filters =
    requirement === 'reward' ? rewardsStepState.condition.filters : requirementsStepState[requirement].filters;
  const filtersAppliedList = useMemo(() => getFiltersAppliedList(filters), [filters]);

  const onButtonClick = (filter: FilterResourceType) => {
    if (requirement === 'reward') {
      rewardsStepDispatch({
        type: RewardsStepActions.SET_ACTIVE_FILTER,
        payload: filter,
      });
    } else {
      requirementsStepDispatch({
        type: RequirementsStepActions.SET_ACTIVE_FILTER,
        payload: {
          filter,
          requirement,
        },
      });
    }
  };

  return (
    <>
      {filtersAppliedList.length === 0 && 'None'}
      {filtersAppliedList.length > 0 &&
        filtersAppliedList.map((filter, index) => (
          <React.Fragment key={filter.text}>
            <FiltersAppliedButton
              key={filter.text}
              type='button'
              onClick={() => onButtonClick(filter.filterResourceType as FilterResourceType)}
            >
              {filter.text}
            </FiltersAppliedButton>
            {index < filtersAppliedList.length - 1 && !excludeCommas ? ', ' : ''}
          </React.Fragment>
        ))}
    </>
  );
}

function getFiltersAppliedList(filters: Filters) {
  return Object.entries(filters)
    .filter(([_, filter]) => filter.resources.length > 0)
    .map(([filterResourceType, filter]) => {
      const filterTypeText: string = filter.selectionType === FilterType.INCLUSIONARY ? 'included' : 'excluded';
      const filterResourcePluralNoun =
        filterResourceType === FILTER_RESOURCES.Category ? 'categories' : `${filterResourceType}s`;
      const noun = filter.resources.length === 1 ? filterResourceType : filterResourcePluralNoun;
      return { text: `${filter.resources.length} ${noun} ${filterTypeText}`, filterResourceType };
    });
}

export const FiltersAppliedButton = styled.button`
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  font: var(--font-small-13pt-normal);
  background: transparent;
  color: var(--color-blue-60);
`;
